import React, { useState } from "react";
import { auth, firestore } from "../../firebase";
import "./style.css";
//this might be slowing the code!
//https://www.npmjs.com/package/react-password-strength-bar
import PasswordStrengthBar from "react-password-strength-bar";

const SignUp = () => {
  const [userEmail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRulesChecker, setPasswordRulesChecker] = useState(true);
  const [passwordVerify, setPasswordVerify] = useState("");
  const [matchingPassword, setMatchingPassword] = useState("");
  const [webTermsCheck, setWebTermsCheck] = useState(false);
  const [webTermsChecker, setWebTermsChecker] = useState(true);

  // const [imageAsFile, setImageAsFile] = useState('')

  const [userFullName, setUserFullName] = useState("");
  // const [userLocation, setUserLocation] = useState("");
  // const [userExpYears, setUserExpYears] = useState("");
  // const [userSpecializations, setUserSpecializations] = useState("");
  const [error, setError] = useState(null);

  const createUserWithEmailAndPasswordHandler = async (
    event,
    userEmail,
    password
  ) => {
    event.preventDefault();
    // if(password!==setPasswordVerify){
    //   setMatchingPassword("סיסמאות לא תואמות")
    //   return;
    // }
    var passwordRules=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if(!(password.match(passwordRules))){
      setPasswordRulesChecker(false)
      return;
    } 
    if(!webTermsCheck){
      setWebTermsChecker(false)
      return;
    }
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        userEmail,
        password
      );
      user.sendEmailVerification({url:'http://localhost:3000/SignIn'});

      const userRef = firestore.doc(`usersData/${user.uid}`);
      const snapshot = await userRef.get();

      // const mainImage = storage.ref(`usersImages`).child(imageAsFile.name);
      // await mainImage.put(imageAsFile)
      // const imageDownloadUrl = await mainImage.getDownloadURL()

      if (!snapshot.exists) {
        try {
          await userRef.set({
            userFullName,
            userEmail,
            // userLocation,
            // userExpYears,
            // userSpecializations,
            // imageDownloadUrl
          });
        } catch (error) {
          console.error("Error creating user document", error);
        }
      }
    } catch (error) {
      setError("הייתה בעיה בהרשמה, אנא נסו שנית");
    }
    setUserEmail("");
    setPassword("");
    setPasswordVerify("");
    setUserFullName("");
    // setUserLocation("");
    // setUserExpYears("");
    // setUserSpecializations("");
    window.location = "/Thankyou";
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name === "userEmail") {
      setUserEmail(value);
    } else if (name === "fullName") {
      setUserFullName(value);
    } else if (name === "userPassword") {
      setPassword(value);
    } else if (name === "userPasswordVerify") {
      setPasswordVerify(value);
    }else if (name === "webTerms") {
      console.log(!webTermsCheck);
      setWebTermsCheck(!webTermsCheck);
    }
    // } else if (name === "userLocation") {
    //   setUserLocation(value);
    // } else if (name === "userExpYears") {
    //   setUserExpYears(value);
    // } else if (name === "userSpecializations") {
    //   setUserSpecializations(value);
    // }
  };
  // const handleImageAsFile = (e) => {
  //     const image = e.target.files[0]
  //     setImageAsFile(imageFile => (image))
  // }
  return (
    <div className="signup-main-block signup-div">
      <div className="signup-div">
        {error !== null && <div className="signup-error">{error}</div>}
        <form className="signup-form">
          {/* <label htmlFor="imageAsFile">
            Your Image:
          </label>
          <input
            type="file"
            name="imageAsFile"
            id="imageAsFile"
            onChange={handleImageAsFile}
          /> 
          {/* <label htmlFor="userLocation">
            Your Work Location:
          </label>
          <input
            type="text"
            name="userLocation"
            value={userLocation}
            placeholder="E.g: Haifa"
            id="userLocation"
            onChange={event => onChangeHandler(event)}
          />
          <label htmlFor="userExpYears">
            How Many Years Of Experience Do You Have?
          </label>
          <input
            type="text"
            name="userExpYears"
            value={userExpYears}
            id="userExpYears"
            onChange={event => onChangeHandler(event)}
          />
          <label htmlFor="userSpecializations">
            Insert Two Of Your Specializations:
          </label>
          <input
            type="text"
            name="userSpecializations"
            value={userSpecializations}
            id="userSpecializations"
            onChange={event => onChangeHandler(event)}
          /> */}
          <h1 className="signup-title">הרשמה לאתר</h1>
          <div className="signup-info signup-div">
            <label htmlFor="fullName">שם מלא:</label>
            <input
              className="signup-input"
              type="text"
              name="fullName"
              value={userFullName}
              placeholder="שם ושם משפחה"
              id="fullName"
              onChange={(event) => onChangeHandler(event)}
            />
            <label htmlFor="userEmail">מייל:</label>
            <input
              className="signup-input"
              type="email"
              name="userEmail"
              value={userEmail}
              placeholder="מייל (עדיפות מייל עסקי)"
              id="userEmail"
              onChange={(event) => onChangeHandler(event)}
            />
            <label htmlFor="userPassword">בחר סיסמה:</label>
            <input
              className="signup-input"
              type="password"
              name="userPassword"
              value={password}
              placeholder="חייבת להכיל אות גדולה באנגלית, אות קטנה ומספר"
              id="userPassword"
              onChange={(event) => onChangeHandler(event)}
            />
            <span style={{color: "red", fontWeight: "700"}}>{passwordRulesChecker?"": ".סיסמה חייבת להכיל לפחות אות גדולה אחת ומספר"} </span>
            {password ? (
              <PasswordStrengthBar
                password={password}
                scoreWords={["חלשה מאוד","חלשה","בינונית","חזקה","חזקה מאוד"]}
                shortScoreWord = "קצרה מדי"
                minLength = {6}
              />
            ) : (
              <span />
            )}
            {/* <label htmlFor="userPasswordVerify">
            :אימות סיסמה
          </label>
          <input
            className ="signup-input"
            type="password"
            name="userPasswordVerify"
            value={passwordVerify}
            placeholder=""
            id="userPasswordVerify"
            onChange={event => onChangeHandler(event)}
          /> */}
          </div>
          {/* <span className="matching-password">{matchingPassword}</span> */}
          <div className="signup-div webTerms-div">
            <p style={{ height: "200px" }}>
            <ol className="signup-terms-list"> תנאי שימוש
              <li className="signup-terms-list"> כללי
                <ol>
                <li>להלן יובאו תנאי השימוש באתר האינטרנט Lawyerz.com (להלן – "לויירז" או "האתר") והשירותים השונים שהאתר מציע (להלן – "השירותים"). באישור תנאי השימוש, הנך מסכים ומאשר כי הנך כפוף לתנאים המפורטים בתנאי השימוש המפורטים להלן, היוצרים הסכם משפטי מחייב בינך לבין לויירז.</li>
                <li>לויירז הינו פלטפורמה אינטרנטית המיועדת לעורכי דין בלבד. מטרת הפלטפורמה הינה, בין היתר, להסדיר את אופן הפניית התיקים בין עורכי הדין המנויים באתר, תוך דרישה כי משתמשי האתר יקפידו לשמור על כללים ברורים שיעמדו בסטנדרטים הנדרשים מהם כעורכי דין ובאופן שיבטיח ללקוחותיהם את השירות המקצועי והיעיל ביותר. בהיותו פלטפורמה לשימוש עורכי דין בלבד, מאפשר האתר בנוסף לעורכי הדין המנויים בו, לערוך התייעצויות מקצועיות ביניהם ואף לפנות למשתמשים אחרים לצורך קבלת ליווי או סיוע בתיק או עניין משפטי.  </li>
                <li>באמצעות האתר או השירותים, לויירז מאפשר לך כמשתמש, בין היתר, גישה ללוח הפניית תיקים או עניינים משפטיים בין עורכי הדין העושים שימוש באתר (להלן – "המשתמש" או "המשתמשים") (ראה הרחבה בסעיף ‏2 להלן), גישה לפורום התייעצויות מקצועיות (ראה הרחבה בסעיף ‏3 להלן) וגישה ללוח "באתי לעזרת חבר" (ראה הרחבה בסעיף ‏4 להלן). </li>
                <li>בשימוש באתר או בשירותים, אתה מסכים לתנאי השימוש המפורטים להלן ואתה מבין כי האתר אינו משרד עורכי דין, אינו מספק שירותים משפטיים, אינו תחליף לייעוץ משפטי ואינו מייצר יחסי עורך דין – לקוח בין האתר לבין המשתמשים. לפיכך, ככל שאינך מסכים לתנאים המפורטים בתנאי השימוש, אנו ממליצים כי לא תירשם לאתר ולא תעשה שימוש בו או בשירותים המוצעים בו.</li>
                <li>השימוש באתר או בשירותים, לרבות השימוש בלוח ההתייעצויות המקצועיות לצורך קבלת ייעוץ ממשתמשים אחרים, בין היתר, לצורך מתן שירותים משפטיים או עסקיים, אינם מהווים ייעוץ משפטי המחייב את האתר או את המשתמשים באתר. עשיית שימוש כלשהו בייעוץ שקיבלת בעת השימוש באתר הינו על דעתך ואחריותך בלבד.</li>
                <li>לויירז שומר לעצמו את הזכות לעדכן את תנאי השימוש מעת לעת. באישורך את תנאי השימוש, הנך מסכים כי האתר והשירותים עשויים להשתנות מעת לעת, במתן הודעה מראש או ללא הודעה כלל והאתר לא יישא באחריות כלפיך או כלפי צד שלישי בכל עניין אי עמידה בתנאי השימוש אף לאחר עדכונם.</li>
                </ol>
              </li>
              <ol className="signup-terms-list"> הפניית תיקים באמצעות לוח הפניות התיקים באתר s
              <li>משתמשי האתר רשאים לפרסם פניה אישית או פומבית באמצעות לוח הפניות התיקים באתר לצורך הפניית תיקים או עניינים משפטיים הנמצאים בטיפולם, לטיפולם של משתמשים אחרים באתר, בכפוף לעמידה בתנאים המפורטים בתנאי השימוש לעיל ולהלן. </li>
              <li>משתמשי האתר רשאים להציע לקבל לטיפולם תיקים או עניינים משפטיים, ביחס לפניה אישית או פומבית אשר פורסמה על ידי משתמשים אחרים בלוח ההפניות באתר.</li>
              <li></li>
              </ol>
              </ol>
              <div className="webTerms">
                <input
                  type="checkbox"
                  id="webTerms"
                  name="webTerms"
                  onChange={(event) => onChangeHandler(event)}
                />
                {/* make it go to a new tab in case of user doesnt exist */}
                {/* <a href="/TermsAndPrivacy">ומסכים לתקנון<a/> */}
                <label for="webTerms">קראתי ומאשר את תנאי השימוש <a href="terms" target="_blank"> ומדיניות הפרטיות</a></label>
                <br />
              </div>
              <span style={{color: "red", fontWeight: "700"}}>{webTermsChecker?"": "נא לקרוא ולהסכים על התקנון ומידניות הפרטיות"} </span>

            </p>
          </div>
          <button
            className="signup-button"
            onClick={(event) => {
              createUserWithEmailAndPasswordHandler(event, userEmail, password);
            }}
          >
            הרשמה
          </button>
        </form>
        <p className="signup-have-account">
          יש לך חשבון קיים?{" "}
          <a href="/SignIn" className="signup-click-here">
            לחץ כאן
          </a>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
